<template>
  <div class="page page-select-cube">
    <SelectCube />
  </div>
</template>

<script>
  import SelectCube from '@/components/SelectCube.vue'

  export default {
    name: 'page-select-cube',
    components: {
      SelectCube,
    },
  }
</script>
